module.exports = __webpack_public_path__ + "static/media/info-icon.956f4729.svg";